var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10387_62744)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#E2E6F5"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_10387_62744)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.479 34.3335V44.4015V55.3224H21.8428V24.3754H50.479V34.3335Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4794 56.6978H21.8432L20.4678 55.3224V24.3754L21.8432 23H50.4794L51.8549 24.3754V55.3224L50.4794 56.6978ZM23.2186 53.947H49.104V25.7508H23.2186V53.947Z",
    fill: "#4611A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.375 24.3754V55.4324L42.9141 62.5296V30.5923L21.375 24.3754Z",
    fill: "#4611A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5019 63.85L20.9353 56.7253L20 55.4049V24.3754L21.7605 23L43.2996 29.2719L44.2899 30.5923V62.5296L42.5019 63.85ZM22.7508 54.4146L41.5391 60.6315V31.6101L22.7508 26.191V54.4146Z",
    fill: "#4611A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9314 38.4323H46.0234V41.1831H63.9314V38.4323Z",
    fill: "#4611A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0361 50.0408L54.0555 48.1427L62.0054 39.8351L53.7529 31.5826L55.6785 29.6295L64.9213 38.8448V40.7704L56.0361 50.0408Z",
    fill: "#4611A7"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10387_62744"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_10387_62744"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.9212,
    height: 40.85,
    fill: "white",
    transform: "translate(20 23)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout-icon.da8b25f83e78893cb1f2daee2bd5939c.svg";
export { ForwardRef as ReactComponent };